import { getUrlDomain } from "./get-domain";

export const UrlUtilities = {

	getUrlDomain: (url: string | undefined): string => {
		return getUrlDomain(url);
	},

	getGoogleMeetLink: (googleMeetCode: string | undefined): string | undefined => {
		if (!googleMeetCode) return undefined;
		return `https://meet.google.com/${googleMeetCode}`;
	},

};